// 产品页假变体
const productVariantBtns = document.querySelectorAll(".product-variant-btn");
productVariantBtns.forEach(function (productVariantBtn) {
  productVariantBtn.setAttribute("role", "tablist");
  const variantItem = productVariantBtn?.querySelectorAll(".item");
  variantItem?.forEach(function (item) {
    item.setAttribute("role", "tab");
    if (item.classList.contains("active")) {
      item.setAttribute("aria-selected", "true");
    }
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const skipLinks = document.querySelectorAll('.skip-link, .skip-to-content-link');
  skipLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById(e.currentTarget.hash.slice(1));
      if (!target) return;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start' });
    });
  });
});


function announcementAccessFun() {
  document.addEventListener('DOMContentLoaded', function () {
    const announcement = document.getElementById('accessibility-announcement');
    // 创建一个函数来发布声明
    function announceAccessibilityStatement() {
      // 将声明的内容复制到屏幕可见区域
      const visibleAnnouncement = document.createElement('div');
      visibleAnnouncement.style.position = 'absolute';
      visibleAnnouncement.style.top = '0';
      visibleAnnouncement.style.left = '0';
      visibleAnnouncement.style.width = '1px';
      visibleAnnouncement.style.height = '1px';
      visibleAnnouncement.style.overflow = 'hidden';
      if (!announcement) return;
      visibleAnnouncement.innerHTML = announcement.innerHTML;
      document.body.appendChild(visibleAnnouncement);
      // 移除声明内容（可选）
      setTimeout(() => {
        document.body.removeChild(visibleAnnouncement);
      }, 5000); // 保留一段时间以确保屏幕阅读器能够读取
    }

    // 调用函数发布声明
    announceAccessibilityStatement();
  });
}

function setfocusableAccessibility() {
  const lastFocusableElements = document.querySelectorAll('.last-focusable-element');
  lastFocusableElements.forEach(lastFocusableElement => {
    lastFocusableElement.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        e.preventDefault();
        e.stopPropagation();
        const firstFocusableElement = lastFocusableElement.parentElement.querySelector('.first-focusable-element');
        if (firstFocusableElement) {
          firstFocusableElement.focus();
        } else {
          console.warn('no .first-focusable-element');
        }
      }
    });
  });

  const firstFocusableElements = document.querySelectorAll('.first-focusable-element');
  firstFocusableElements.forEach(firstFocusableElement => {
    firstFocusableElement.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        firstFocusableElement.click();
      }
    });
  });
}

function toggleVideo(videoId) {
  const video = document.getElementById(videoId);
  if (video) {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
}
announcementAccessFun();
setfocusableAccessibility();
toggleVideo();

// Keep the announced disclosure state aligned with the visible hover/focus menu.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.site-header-top-link-item, .site-nav--has-dropdown').forEach((item) => {
    const trigger = item.querySelector(':scope > [aria-haspopup="true"]');
    if (!trigger) return;
    const update = () => trigger.setAttribute('aria-expanded',
      String(item.matches(':hover') || item.contains(document.activeElement)));
    item.addEventListener('focusin', update);
    item.addEventListener('focusout', () => setTimeout(update, 0));
    item.addEventListener('mouseenter', update);
    item.addEventListener('mouseleave', update);
    if (trigger.getAttribute('href') === '#') {
      trigger.addEventListener('click', (event) => event.preventDefault());
    }
  });
});

// Add the actual displayed amount to price names, including prices inserted by bundles.
(function () {
  const priceSelector = '.rbr-total-box-rawPrice, .rbr-total-box-price, [data-price-container] .product_on-sale-price, [data-price-container] #ProductPrice, [data-price-container] .product_compare-at-price, [data-price-container] #ComparePrice';
  const labelClass = 'rbr-price-accessibility-label';
  let pending = false;
  let labelIndex = 0;

  function enhancePrices() {
    pending = false;
    document.querySelectorAll(priceSelector).forEach((element) => {
      const source = element.querySelector('.money') || element;
      const copy = source.cloneNode(true);
      copy.querySelectorAll('.' + labelClass + ', .visually-hidden, .sr-only').forEach((node) => node.remove());
      const amount = copy.textContent.replace(/\s+/g, ' ').trim();
      if (!amount) return;
      const previous = element.matches('.rbr-total-box-rawPrice, .product_compare-at-price, #ComparePrice');
      const labels = window.accessibility || {};
      const prefix = previous ? labels.regular_price : labels.current_price;
      if (!prefix) return;
      let label = element.querySelector('.' + labelClass);
      if (!label) {
        label = document.createElement('span');
        label.className = 'visually-hidden ' + labelClass;
        label.id = 'price-accessibility-label-' + (++labelIndex);
        element.prepend(label);
      }
      const text = prefix + ': ' + amount;
      if (label.textContent !== text) label.textContent = text;
      element.setAttribute('tabindex', '0');
      element.setAttribute('role', 'group');
      element.setAttribute('aria-labelledby', label.id);
      element.removeAttribute('aria-label');
      element.querySelectorAll('.money').forEach((money) => money.setAttribute('aria-hidden', 'true'));
    });
  }

  function relevantMutation(mutation) {
    const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (!target || target.closest('.' + labelClass)) return false;
    const changed = [...mutation.addedNodes, ...mutation.removedNodes];
    if (changed.length && changed.every((node) => node.nodeType === 1 && node.classList.contains(labelClass))) return false;
    if (target.matches(priceSelector) || target.closest(priceSelector)) return true;
    return changed.some((node) => node.nodeType === 1 &&
      (node.matches(priceSelector) || node.querySelector(priceSelector)));
  }

  function initialize() {
    enhancePrices();
    new MutationObserver((mutations) => {
      if (!pending && mutations.some(relevantMutation)) {
        pending = true;
        window.setTimeout(enhancePrices, 80);
      }
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
